import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificacaoModel } from '@app/data/notificacao/models';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { AuthService } from '@infra/auth/auth.service';
import { DetalhesNotificacaoComponent } from '../../components/detalhes-notificacao/detalhes-servico-executado.component';
import { NotificacaoController } from '../../controllers';
import { CustomValidators } from '@app/shared/validators';

@Component({
  selector: 'app-notificacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.scss'],
})
export class NotificacoesComponent extends BaseListagemComponent<NotificacaoModel> {
  public title = 'Notificações - Portal do Cliente';

  protected filtros: Campo[] = [
    {
      name: 'atendimento.numeroAtendimento',
      label: 'Nº Atendimento',
      type: 'text',
      icon: 'insert_drive_file',
      width: '20%',
      mask: '0*',
      validators: [],
    },
    {
      name: 'transacao.dataHora',
      label: 'Data Notificação',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [CustomValidators.data],
    },
    {
      name: 'lida',
      label: 'Situação',
      type: 'select',
      icon: 'check_checked',
      selectOptions: {
        items: [
          { label: 'Lidas', value: "S" },
          { label: 'Não Lidas', value: "N" },
        ],
      },
      value: 'N',
      width: '25%',
    },
  ];

  protected acoes: Acao[] = [];

  protected colunas: Coluna[] = [
    { name: 'numeroAtendimento', label: 'Nº Atendimento' },
    { name: 'descricao', label: 'Descrição' },
    { name: 'dataHora', label: 'Data e Hora' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.verDetalhes.bind(this),
        },
      ],
    },
  ];

  constructor(public notificacaoController: NotificacaoController, private authService: AuthService, private dialog: MatDialog) {
    super('Notificações - Portal do Cliente', notificacaoController);
  }

  private verDetalhes(notificacao: any) {
    const ref = this.dialog.open(DetalhesNotificacaoComponent, {
      width: '900px',
      height: '700px',
      data: { id: notificacao.codigoNotificacaoAtendimento },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();
      }
    });
  }
}
